import { useStmCartStoreBase } from '@cart-services/hooks/use-stm-cart-store'
import { Button } from '@pets-ui/Button/Button'
import { HStack } from '@pets-ui/HStack/HStack'
import { CartFilled } from '@pets-ui/icons'
import { Image } from '@pets-ui/Image/Image'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { useHistory } from 'react-router-dom-v5'
import { brandImageMap } from '../../constants'
import { useStmBrandStore } from '../../hooks'

interface CartReminderProps {
  basePath: string
}

export const CartReminder = ({ basePath }: CartReminderProps) => {
  const history = useHistory()
  const { brands } = useStmBrandStore()
  const cartState = useStmCartStoreBase()

  const uncheckedBrands = brands.filter(brand =>
    (cartState[brand.campaignId]?.cart.items.length ?? 0) > 0,
  )

  if (uncheckedBrands.length === 0) return null

  const handleContinueCheckout = () => {
    history.push(`${basePath}/cart`)
  }

  return (
    <VStack gap={3} p={3} borderRadius={8} backgroundColor={colors.white}>
      <Text variant="subtitle">未結帳提醒</Text>
      <HStack gap={2} alignItems="center" justifyContent="center" width="100%">
        <HStack gap={1}>
          {uncheckedBrands.map((brand) => {
            const assets = brandImageMap[brand.projectCode]
            return (
              <Image
                key={brand.campaignId}
                src={assets?.avatar}
                width={24}
                height={24}
                alt={brand.projectCode}
              />
            )
          })}
        </HStack>
        <Text color={colors.grey800}>
          目前還有
          {' '}
          <Text component="span" color={colors.red600}>{uncheckedBrands.length}</Text>
          {' '}
          個品牌尚未結帳
        </Text>
      </HStack>
      <Button fullWidth color="red" startIcon={<CartFilled />} onClick={handleContinueCheckout}>
        繼續結帳
      </Button>
    </VStack>
  )
}
